import Sider from "antd/es/layout/Sider";
import React from "react";
import { Button, Card, Row } from "antd";
import GoogleCalendarLogin from "../GoogleCalendarLogin";
import {
  CheckOutlined,
  LoadingOutlined,
  SyncOutlined,
} from "@ant-design/icons";
import { useSyncResources } from "../../queries/resource";
import { useTranslation } from "react-i18next";

const UtilityPanel = () => {
  const { t } = useTranslation();
  const { isSuccess, isLoading, refetch } = useSyncResources({
    enabled: false,
  });

  return (
    <Sider
      style={{
        textAlign: "center",
        backgroundColor: "#FFFFFF",
      }}
      width={"20%"}
    >
      <Row justify="center" align="middle" style={{ marginTop: "2.5rem" }}>
        <Card
          title={t("utility-panel.connect-calendar-providers")}
          style={{ maxWidth: 500 }}
        >
          <GoogleCalendarLogin onConnectSuccessful={() => refetch()} />
        </Card>
      </Row>
      <Row justify="center" align="middle" style={{ marginTop: 40 }}>
        <Button onClick={() => refetch()} style={{ width: 200 }}>
          {isLoading ? (
            <LoadingOutlined />
          ) : isSuccess ? (
            <CheckOutlined />
          ) : (
            <SyncOutlined />
          )}
          {t("utility-panel.synchronize-calendars")}
        </Button>
      </Row>
    </Sider>
  );
};

export default UtilityPanel;
